const getLanguage = () => localStorage.getItem('i18nextLng') || 'en-US';

const formatCalories = (calories: number) => {
  return Intl.NumberFormat(getLanguage(), {
    style: 'decimal',
    useGrouping: true,
    maximumFractionDigits: 0,
  }).format(calories);
};

/**
 * Formats a number with the decimal separator of the current app language (e.g. 2,5 for pl-PL).
 * @param value number to format
 * @param maxFractionDigits maximum number of digits after the decimal separator
 */
const formatDecimal = (value: number, maxFractionDigits = 1) => {
  return Intl.NumberFormat(getLanguage(), {
    style: 'decimal',
    useGrouping: true,
    maximumFractionDigits: maxFractionDigits,
  }).format(value);
};

export { formatCalories, formatDecimal };
